export default __webpack_public_path__ + "img/f44fd1d38c77e79fcd2d27193ca67e8d.png";